"use strict";

var _toConsumableArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MovableSprite = exports.FreeMoveSprite = void 0;

var _react = _interopRequireDefault(require("react"));

var PIXI = _interopRequireWildcard(require("pixi.js"));

var _ = require(".");

var _Ticker = require("../Ticker");

var _Sprite = require("./Sprite");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FreeMoveSprite = function FreeMoveSprite(_ref) {
  var textures = _ref.textures,
      source = _ref.source,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["textures", "source", "children"]);

  return _react.default.createElement(_.AnimatedSprite, _extends({}, props, {
    textures: textures
  }), children, _react.default.createElement(_Sprite.SpriteContext.Consumer, null, function (sprite) {
    return sprite instanceof PIXI.AnimatedSprite && _react.default.createElement(_Ticker.Subscribe, {
      source: source,
      update: function update(_ref3) {
        var position = _ref3.position,
            rotation = _ref3.rotation;
        sprite.position.x = position.x;
        sprite.position.y = position.y;
        if ('degree' in rotation && rotation.degree !== sprite.angle) sprite.angle = rotation.degree;else if ('radian' in rotation && rotation.radian !== sprite.rotation) sprite.rotation = rotation.radian;
      }
    });
  }));
}; //#endregion
//#region limited direction move


exports.FreeMoveSprite = FreeMoveSprite;

var MovableSprite = function MovableSprite(_ref2) {
  var animId = _ref2.animId,
      textures = _ref2.textures,
      source = _ref2.source,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, ["animId", "textures", "source", "children"]);

  var id = animId instanceof Function ? animId(0, 0) : animId;
  return _react.default.createElement(_.AnimatedSprite, _extends({}, props, {
    textures: id === undefined ? textures : textures[id]
  }), children, _react.default.createElement(_Sprite.SpriteContext.Consumer, null, function (sprite) {
    return sprite instanceof PIXI.AnimatedSprite && _react.default.createElement(_Ticker.Subscribe, {
      source: source,
      update: function update(_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            _ref5$ = _slicedToArray(_ref5[0], 2),
            x = _ref5$[0],
            y = _ref5$[1],
            velocity = _ref5[1];

        sprite.position.x = x;
        sprite.position.y = y;
        var id = animId instanceof Function ? animId.apply(void 0, _toConsumableArray(velocity)) : animId;
        if (id === undefined || textures[id] === sprite.textures) return;
        var playing = sprite.playing;
        sprite.textures = textures[id];
        playing && sprite.play();
      }
    });
  }));
};

exports.MovableSprite = MovableSprite;
MovableSprite.UDLR = {
  animId: function animId(vx, vy) {
    return vx === 0 ? vy === 0 ? 'idle' : vy < 0 ? 'up' : 'down' : vx < 0 ? 'left' : 'right';
  }
};

MovableSprite.toUDLR = function (textures) {
  var eachSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  return {
    idle: textures.slice(0, eachSize),
    up: textures.slice(1 * eachSize, 2 * eachSize),
    down: textures.slice(2 * eachSize, 3 * eachSize),
    left: textures.slice(3 * eachSize, 4 * eachSize),
    right: textures.slice(4 * eachSize, 5 * eachSize)
  };
}; //#endregion